import { ChangeDetectionStrategy, Component, OnInit, Inject, Input, HostBinding } from '@angular/core';
import { PlacementArray } from '@ng-bootstrap/ng-bootstrap/util/positioning';
import { IS_MOBILE_TOKEN } from '@anecdotes/design-system/injection-tokens';

@Component({
  selector: 'app-monitored-label',
  templateUrl: './monitored-label.component.html',
  styleUrls: ['./monitored-label.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MonitoredLabelComponent implements OnInit {
  @HostBinding('class.published-page')
  private get isPublishedPage(): boolean {
    return !this.isEditing;
  }

  tooltipPlacement: PlacementArray;

  tooltipTriggers: string;

  @Input({ required: true })
  isEditing: boolean;

  constructor(@Inject(IS_MOBILE_TOKEN) readonly isMobile: boolean) {}

  ngOnInit(): void {
    this.tooltipPlacement = this.isMobile
      ? 'bottom bottom-start bottom-end top-start top-end auto'
      : 'top top-start top-end bottom-start bottom-end auto';

    this.tooltipTriggers = this.isMobile ? 'click' : 'hover focus';
  }

  buildTranslationKey(key: string): string {
    return `trustCenter.monitoredLabel.${key}`;
  }
}
